// src/services/auth.ts
export interface UserProfile {
  id: number;
  email: string;
  role: string;
  timezone: string;
}

// function getCookie(name: string) {
//   return document.cookie
//     .split("; ")
//     .find(r => r.startsWith(name + "="))
//     ?.split("=")[1] ?? "";
// }

export async function login(email: string, password: string, remember = false) {
  const base = import.meta.env.VITE_API_URL || "";

  const r1 = await fetch(`${base}/auth/login`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({ username: email, password }),
  });
  if (!r1.ok) throw new Error(await r1.text());

  const r2 = await fetch(`${base}/auth/attach-refresh`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ remember }),                       // 👈 here
  });
  if (!r2.ok) throw new Error(await r2.text());
}

export async function logout(): Promise<void> {
  const base = import.meta.env.VITE_API_URL || "";
  await fetch(`${base}/auth/logout-cookie`, {
    method: "POST",
    credentials: "include",
  });
  // No local storage cleanup needed; cookies are cleared server-side
}

export async function getCurrentUser(): Promise<UserProfile> {
  const base = import.meta.env.VITE_API_URL || "";

  const userRes = await fetch(`${base}/auth/me`, {
    credentials: "include",
  });
  if (!userRes.ok) throw new Error("Failed to fetch user info");
  const userData = await userRes.json();

  const profileRes = await fetch(`${base}/user/profile/`, {
    credentials: "include",
  });

  let timezone = "UTC";
  if (profileRes.ok) {
    const profileData = await profileRes.json();
    timezone = profileData.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  } else {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  return {
    id: userData.id,
    email: userData.email,
    role: userData.role,
    timezone,
  };
}
